import React from 'react'
import PropTypes from 'prop-types'

import CommonReport from 'component/commonReport/CommonReport'

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'

import * as adjustmentValuesActions from 'action/adjustmentValues'
import * as reportActions from 'action/report'
import applyMask from 'component/report/utils/Formatter'
import moment from 'moment'

let abortController
const ADJUSTMENT_VALUES_CSV = 48

class AdjustmentValues extends React.Component {
  state = {
    body: {},
  }

  getFilterFields() {
    const {
      translate,
      auth: { user }
    } = this.props

    return [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('rotativeInventory.dsBranch'),
        help_text: translate('adjustmentValues.branch.select'),
        required: !user.isLdapInManager
      },
      {
        type: 'sections',
        name: 'lsSections',
        label: translate('section'),
        help_text: translate('adjustmentValues.section.select'),
      },
      {
        type: 'date_range',
        name: 'period',
        label: translate('adjustmentValues.date.period'),
        error_text: translate('adjustmentValues.date.select'),
        required: true,
      },
    ]
  }

  async getCsv() {
    const {
      auth: {
        user: { dsToken },
      },
      fetchFluxReport,
      translate
    } = this.props
    const { body } = this.state

    abortController = new AbortController()
    await fetchFluxReport(dsToken, { tpReport: ADJUSTMENT_VALUES_CSV }, body, translate, abortController )

    return true
  }

  async onSubmit(body) {
    const {
      auth: { user },
      v2Fetch
    } = this.props
    body.dtStart = moment(body.period[0]).format('DD/MM/YYYY')
    body.dtEnd = moment(body.period[1]).format('DD/MM/YYYY')
    body.size = 999
    body.page = 1
    body.offset = 0

    this.setState({ body })

    abortController = new AbortController()
    await v2Fetch(user.dsToken, body, abortController)

    return this.buildRows()
  }

  buildRows() {
    const { records, translate } = this.props

    const rows = []

    if (records) {
      const subtotalData = {}

      records.branchData.map((branch) => {
        const row = {}
        row.store = branch.dsBranch ? branch.dsBranch.replace('LOJA ', '') : '-'
        records.sectionData.map((section) => {
          const { adjustValue, maskedValue } = this.getData(branch, section)

          if (subtotalData[section.cdSection]) {
            subtotalData[section.cdSection] += adjustValue
          } else {
            subtotalData[section.cdSection] = adjustValue
          }

          row[`s_${section.cdSection}`] = maskedValue
        })
        row.total = this.getFinalValue(branch.adjustValue)

        rows.push(row)
      })

      const subRow = {}
      let subtotalSum = 0
      subRow.store = <strong>{translate('subtotal')}</strong>
      records.sectionData.map((section) => {
        const curSubtotal = subtotalData[section.cdSection]
        subtotalSum += Math.round((curSubtotal + Number.EPSILON) * 100) / 100
        subRow[`s_${section.cdSection}`] = (
          <strong>{this.getFinalValue(curSubtotal)}</strong>
        )
      })
      subRow.total = <strong>{this.getFinalValue(subtotalSum)}</strong>
      rows.push(subRow)

      const totRow = {}
      totRow.store = <strong>{translate('total_lmb_label')}</strong>
      records.sectionData.map((section) => {
        totRow[`s_${section.cdSection}`] = (
          <strong>{this.getFinalValue(section.adjustValue)}</strong>
        )
      })
      totRow.total = <strong>{this.getFinalValue(records.totalData)}</strong>
      rows.push(totRow)
    }

    const response = {
      data: rows,
      total: 1,
    }

    return response
  }

  getData = (branch, section) => {
    const { records } = this.props

    const data = records.mainData.find(
      (main) =>
        main.idBranch === branch.idBranch &&
        main.cdSection === section.cdSection
    )

    const adjustValue = data ? data.adjustValue : 0

    return {
      adjustValue,
      maskedValue: this.getFinalValue(adjustValue),
    }
  }

  getFinalValue = (value) => {
    const { translate } = this.props

    return value ? applyMask('currency-alt', value, translate) : '-'
  }

  buildColumns() {
    const { records } = this.props

    let columns = {}

    if (records) {
      records.sectionData.map((section) => {
        columns[`s_${String(section.cdSection)}`] = {
          label: `${section.cdSection} - ${section.dsSection}`,
          align: 'left',
          disableOrder: true,
        }
      })

      columns = {
        store: {
          label: 'Loja',
          align: 'left',
          fixed: true,
        },
        ...columns,
        total: {
          label: 'Total',
          align: 'left',
          disableOrder: true,
        },
      }
    }

    return columns
  }

  render() {
    const {
      auth: { user },
      translate,
    } = this.props

    const reportProperties = {
      title: translate('stock.adjustment.adjustmentValues.title'),
      order: true,
      defaultOrder: 'store',
      onExport: async (callback) => {
        const ok = await this.getCsv()

        callback(ok)
      },
      onSubmit: async (body, callback) => {
        const response = await this.onSubmit(body)
        callback(response)
      },
      columns: this.buildColumns(),
      fields: this.getFilterFields(),
    }
    return (
      <CommonReport {...reportProperties} user={user} translate={translate} />
    )
  }
}

AdjustmentValues.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  records: PropTypes.object,
  v2Fetch: PropTypes.func.isRequired,
  fetchFluxReport: PropTypes.func.isRequired,
}

const mapStateToProps = ({ adjustmentValuesReducer }) => ({
  records: adjustmentValuesReducer.records,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...adjustmentValuesActions, ...reportActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    AdjustmentValues
  )
)

export { AdjustmentValues }
